import React from 'react';

import {TagChip} from 'presentation/components';
import Icon from 'presentation/icons';
import {useTheme} from 'styled-components';
import {translations} from 'presentation/translations-new';

const {onlyTelemedicineSpecialty} = translations['pt-br'].privateFlow.bookingFlow.specialtyFlow;

export function OnlyTelemedicineChip() {
	const {colors} = useTheme();

	return (
		<TagChip
			label={onlyTelemedicineSpecialty}
			bgColor={colors.light.primary['30Percent']}
			icon={
				<Icon
					name="video-camera-front-filled"
					size={18}
					color={colors.brand.primary.blue}
				/>
			}
			sx={{
				px: 1,
			}}
		/>
	);
}
